import logo from "../assets/images/logo.png"
import logo_c from "../assets/images/company_logo.png"
export default {
    home: {
        welcome1: 'Watcher',
        welcome2: 'Library',
        logo,
        lang: [
            {
                title: '繁體中文',
                key: 'zh-tw'
            },
            {
                title: '简体中文',
                key: 'zh-cn'
            },
            {
                title: 'English',
                key: 'en'
            },
            {
                title: '日本語',
                key: 'ja'
            },
            {
                title: '한국어',
                key: 'ko'
            }
        ],
        reward: "Limited Reward",
        welfare: "Limited Benefit",
        up: "Event Description",
        activity: {
            time: {
                title: "Event Time:",
                year_start: "Nov. 21st of ",
                year_end: "Feb. 3rd of ",
                month_day_start: "2019 ",
                month_day_end: "2020 at 02:00 (UTC)",
            },
            content: {
                title: "Event Content:",
                way: [
                    `1. Click [Limited Reward] and retrieve a Sdorica X Gumballs & Dungeons limited collaboration reward.`,
                    `2. Click [Limited Benefit] to head to the collaboration event page to get more rewards.`,
                    `3. You can only get Sdorica's rewards on this page. `,
                    `4. For Gumballs & Dungeons' rewards please head to the Gumballs & Dungeons event page.`,
                    `5. Every individual library account in the SID can retrieve rewards once. After clicking, the reward will be sent directly to the current library used to log in.`,
                    `6. Rewards will be sent via mail and are valid for 30 days. Please confirm after receiving it.`
                ]
            }
        }
    },
    welfare: {
        back: "Home",
        welcome1: 'Watcher',
        welcome2: 'Library',
        gumballs_activity: {
            time: {
                title: "Event Time:",
                year_start: "Nov. 21st of ",
                year_end: "Feb. 3rd of ",
                month_day_start: "2019 ",
                month_day_end: "2020 at 02:00 (UTC)",
            },
            content: {
                title: "Event Content:",
                way: [
                    `1. Click [Get Gumballs & Dungeons Event Code] and retrieve a Gumballs & Dungeons' limited collaboration event code. `,
                    `2. Press [Download Gumballs & Dungeons] and install Gumballs & Dungeons.`,
                    `3. Go to the Gumballs & Dungeons main map > settings button in the upper-right hand corner > enter the secret code`
                ]
            },
            get_code: "Get Gumballs & Dungeons Event Code",
            download: "Download Gumballs & Dungeons"
        },
        sdorica_activity: {
            time: {
                title: "Event Time:",
                year_start: "Nov. 21st of ",
                year_end: "Feb. 3rd of ",
                month_day_start: "2019 ",
                month_day_end: "2020 at 02:00 (UTC)",
            },
            content: {
                title: "Event Content:",
                way: [
                    `1. Head to the Gumballs & Dungeons collaboration event page to get Sdorica's limited collaboration code.`,
                    `2. Enter the code in the box below and retrieve the gift.`,
                    `3. Every individual library account in the SID can retrieve a reward only once.`,
                    `4. Confirm your Library account and user name before getting the reward. The code won't be available after you retrieve your reward.`,
                    `5. Reward will be sent via mail and is valid for 30 days. Please confirm after receiving it.`
                ]
            },
            label: "Event Code:",
            placeholder: "Click to enter the event code.",
            noEnter_placeholder: "Please enter the event code first.",
            get_welfare: "Get Sdorica's limited benefit",
            got_welfare: "Already collected"
        }
    },
    get_reward: {
        done: {
            title: "Successfully received!",
            content: ["Reward has been sent in the mail.", "Please check in the game."]
        },
        failed: {
            title: "Failed to receive!",
            retry:"Please try again."
        }
    },
    code_config: {
        title: "Gumballs & Dungeons' Limited Event Code",
        copy: "Copy",
        download: "Download Gumballs & Dungeons amd head to the relevent event page to use it.",
        success: 'Copy Success!'

    },
    rightCode: 'Please enter the correct event code.',
    messageFailed: "Successfully received already.",
    footer: {
        logo: logo_c,
        company: "© 2019 Rayark Inc. All rights reserved.",
        caseNumber: "",
        copyright: "",
        publicSecurityRecordNumber: "",
        wangwen: ""

    },
    resize: 'Please adjust your phone/table to vertical mode.',
    notFound: 'Sorry. Page not found.',
    network_error: {
        INVALID_REWARD_TYPE: 'Incorrect rewards',
        EXIST_REWARD_RECORD: 'Already collected rewards',
        INVALID_CODE: 'Code verification failed',
        CODE_USED: 'This code is already taken',
        GAMEDATA_INVALID_VALUE: 'Failed to receive',
        OTHER:'Failed to receive',
        NO_TOKEN:'Please click the in-game event banner to join this event'
    }

}